import { Box, Text } from '@chakra-ui/react';

function Tiles({ id, isHovered, onHover, onLeave, adjacentHovered }) {
  const isReduced = adjacentHovered && !isHovered; // Check if the adjacent tile is being hovered

  return (
    <Box
      h="150px"
      w={isHovered ? '550px' : isReduced ? '350px' : '450px'} // Adjust width dynamically
      bg="gray.100"
      transition="width 0.3s ease"
      onMouseEnter={() => onHover(id)}
      onMouseLeave={onLeave}
      display="flex"
      alignItems="center"
      justifyContent="center"
      position="relative"
    >
      <Text>{`Tile ${id + 1}`}</Text>
    </Box>
  );
}

export default Tiles;